// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const DownloadTopicTree = () => {

   const [text, set_text] = React.useState();

   const build = async ({ set_body, set_foot, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      set_body(
         <div className="ask-henry-body-margin-bottom-x">
           <p className="ask-henry-body-margin-bottom-x">Download the topic tree.</p>
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Submit{app.who()}</button>
           <button className="ask-henry-form-button" onClick={form_close} >Cancel</button>
         </>
      );

   } // build();

   const enact = async ({ set_form, set_warn, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      var response = await api.fetch('dbs/tree/dump/1', api.token(), api.log(true), api.headers({responseType: 'blob'}));

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
         }
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.FINAL);
         var text = 'The topic tree has been down loaded to the file ' + response.file + '.';
         set_text(response.file);
         app.set_state('status', 'Downloaded ' + response.file);
      }

   } // enact();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(
         <>
           <p className="ask-henry-body-margin-bottom-x">The topic tree has been downloaded to the text file:</p>
           <p className="ask-henry-body-margin-bottom-x">{text}</p>
         </>
      );
      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
   } // final();

   return <Form build={build} enact={enact} final={final} title={'Download Topic Tree' + app.who()} />

} // <DownloadTopicTree />;

export default DownloadTopicTree;
